export enum ContactTypes {
  SameAsOwner = 0,
  Other = 1,
  KeyAtAgency = 2
}
